import { Level2, Level3, Level4 } from '../StyledOl';

const WarrantyPeriod = () => (
  <li>
    WARRANTY PERIOD
    <Level2>
      <li>
        The Warranty Period shall commence on the Commissioning Date. During the Warranty Period,
        the Goods shall meet warranty coverage and the standard of performance and requirements
        specified in the Specifications.
      </li>
      <li>
        During the Warranty Period, the Contractor shall be responsible for the satisfactory and
        reliable operation of the Goods and guarantees that the Goods supplied complies with
        LINK&rsquo;s requirements, including those in the Specifications.
      </li>
      <li>
        During the Warranty Period, the Contractor shall:
        <Level3>
          <li>
            provide regular on-site maintenance of the Goods to ensure that the Goods performs in
            accordance with the Specifications and remains in suitable and optimum operating
            condition at all times;
          </li>
          <li>
            where the Goods or any part thereof is functioning or malfunctioning in such manner that
            it is incapable or is suspected of being incapable of reliably meeting LINK&rsquo;s
            operational requirements, or that the Goods or any part thereof is found to be:
            <Level4>
              <li>
                defective in design or otherwise whether arising from faulty and inferior system
                design, coding or otherwise; or
              </li>
              <li>
                not fit for the purposes or does not meet the standard of performance specified in
                the Specifications; or
              </li>
              <li>
                failing to meet any performance guarantees or additional requirements as may be
                mutually agreed between LINK and the Contractor,
              </li>
            </Level4>
            at the Contractor&rsquo;s own expense (including but not limited to transportation
            costs, air freight charges, costs of testing, manufacturing and examination), provide
            LINK with technical consultations, assistance and advice and commence remedial and
            corrective maintenance or work on the Goods, whether on-site or otherwise, to replace
            (if agreed to by LINK) or completely repair the defective parts of the Goods or
            otherwise completely rectify the defects, and complete the necessary rectification works
            or implement the necessary resolutions within the times stipulated by LINK,
            notwithstanding that such rectification may extend beyond or take place after the end of
            the Warranty Period;
          </li>
          <li>
            provide, install and test any required software bug fixes, upgrades, patches and
            anti-virus signature updates to improve functionality or to address problems and defects
            with the Goods, at no additional cost to LINK;
          </li>
          <li>
            inform LINK of any known or suspected faults, bugs and defects in the Goods as soon as
            they are discovered; and
          </li>
          <li>
            provide LINK with a regular supply of consumables, peripherals, and other supplies
            necessary for the efficient and optimal use of the Goods in accordance with LINK&rsquo;s
            operational requirements.
          </li>
        </Level3>
      </li>
      <li>
        During the Warranty Period, the Contractor shall:
        <Level3>
          <li>
            provide all labour and field installable parts required for maintaining the Goods or any
            part thereof as a result of any defect in the Goods;
          </li>
          <li>
            maintain accurate and comprehensive records of the history of the Contractor&rsquo;s
            maintenance activity for the Goods and each component thereof; and
          </li>
          <li>
            provide technical support, advice and consultation with respect to any use and/or
            testing of the Goods scheduled by LINK.
          </li>
        </Level3>
      </li>
      <li>
        The Contractor shall not be relieved of its obligations in this clause 13 until LINK is
        satisfied that the defects are rectified. Where the Contractor fails to remedy the defects
        within the time stipulated by LINK, LINK shall be entitled to have the defects rectified by
        other contractors or purchase replacement parts from other contractors and all costs
        incurred by LINK in this regard shall be fully borne by the Contractor.
      </li>
      <li>
        LINK shall have the right to extend the Warranty Period if not all defects are fixed by the
        end of the Warranty Period.
      </li>
      <li>
        The Contractor shall not be relieved of any of its obligations in this clause 13 by reason
        of the failure of LINK to make inspection or discover any defects or any aspect of the
        Contractor&rsquo;s default.
      </li>
    </Level2>
  </li>
);

export default WarrantyPeriod;
